var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"value":_vm.isOpen,"color":"#343434","app":"","flat":"","floating":"","permanent":""}},[_c('navigation-drawer-user'),_c('navigation-drawer-my-profile-button'),_c('navigation-drawer-tabs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }